import { createContext } from "react";
import { BSWidgetContextType } from "../../../types/businessSummary";

const BSWidgetContext = createContext<BSWidgetContextType | undefined>(
  undefined
);

export { BSWidgetContext };
